import { useCanvasStore } from '@/stores/canvasStore';

export function ZoomControls() {
  const zoom = useCanvasStore((state) => state.zoom);
  const minZoom = useCanvasStore((state) => state.minZoom);
  const setZoom = useCanvasStore((state) => state.setZoom);
  const setPan = useCanvasStore((state) => state.setPan);

  const handleZoomIn = () => setZoom(zoom * 1.5);
  const handleZoomOut = () => setZoom(zoom / 1.5); // Store enforces minZoom
  const handleReset = () => {
    setZoom(minZoom); // Reset to fit 80% of viewport
    setPan(0, 0);
  };

  return (
    <div className="bg-wall-surface/80 backdrop-blur-xs border border-wall-border/50 rounded-xl p-2 shadow-lg">
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between gap-1">
          <button
            onClick={handleZoomIn}
            className="w-8 h-8 flex items-center justify-center bg-wall-border/50 hover:bg-wall-accent/80 rounded-lg transition-all duration-200 font-medium"
            title="Zoom In"
          >
            +
          </button>
          <div className="text-center text-xs text-wall-muted py-1 min-w-[40px] font-mono">
            {Math.round(zoom * 100)}%
          </div>
          <button
            onClick={handleZoomOut}
            className="w-8 h-8 flex items-center justify-center bg-wall-border/50 hover:bg-wall-accent/80 rounded-lg transition-all duration-200 font-medium"
            title="Zoom Out"
          >
            −
          </button>
        </div>
        <div className="border-t border-wall-border/30 my-1" />
        <button
          onClick={handleReset}
          className="w-full h-8 flex items-center justify-center bg-wall-border/50 hover:bg-wall-accent-secondary/50 rounded-lg transition-all duration-200 text-sm"
          title="Reset View"
        >
          ⟲
        </button>
      </div>
    </div>
  );
}
